// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"60b943af","453":"93a78a56","732":"dd4ee1b1","977":"ef72116f"}[chunkId] + ".chunk.js";
};